import {Box, Grid, Typography} from '@mui/material';
import Em from '../../comps/Em';
import Section from './Section';

const Trails = () => {
  return (
    <Section id='trails'>
      <Typography fontWeight={900} color="primary" textTransform="uppercase" textAlign="center" sx={{
        fontSize: {xs: '3rem', md: '3.75rem'},
      }}>
        The Trails
      </Typography>
      <Typography variant="body1" sx={{
        fontSize: '1.5rem',
      }}>
        All of the cones are located on the <Em>Mosquito Bite</Em>, <Em>Fun Forest</Em> trails, as well as over at <Em>Benchlands Drop Zone</Em> and <Em>Millennium Park</Em>. Below you'll find
        links to Trailforks for more info about these areas.
      </Typography>
      <Box mt={2}>
      <Grid container spacing={1} flexWrap="wrap" justifyContent="center">
        <Grid item xs={12} sm={6} >
          <Typography fontWeight={700} color="primary" textTransform="uppercase" textAlign="center" sx={{
            fontSize: {xs: '1.5rem', md: '1.75rem'},
          }}>
            Mosquito Bite
          </Typography>
          <Box sx={{
            // border: `2px solid`,
            // borderColor: 'primary.main'
          }}>
            <iframe title="Mosquito Bite" width="100%" height="350" style={{maxWidth: '100%'}}
                  src="https://www.trailforks.com/widgets/trail/?trailid=94963&w=512px&h=350px&activitytype=1&map=1&elevation=0&photos=0&title=0&info=0&trail_opacity=25&v=2"></iframe>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} >
          <Typography fontWeight={700} color="primary" textTransform="uppercase" textAlign="center"  sx={{
            fontSize: {xs: '1.5rem', md: '1.75rem'},
          }}>
            Fun Forest
          </Typography>
          <Box sx={{
            // border: `2px solid`,
            // borderColor: 'primary.main'
          }}>
            <iframe title="Fun Forest" width="100%" height="350" style={{maxWidth: '100%'}}
                  src="https://www.trailforks.com/widgets/trail/?trailid=437549&w=512px&h=350px&activitytype=1&map=1&elevation=0&photos=0&title=0&info=0&trail_opacity=25&v=2"></iframe>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} >
          <Typography fontWeight={700} color="primary" textTransform="uppercase" textAlign="center"  sx={{
            fontSize: {xs: '1.5rem', md: '1.75rem'},
          }}>
            Benchlands Drop Zone
          </Typography>
          <Box sx={{
            // border: `2px solid`,
            // borderColor: 'primary.main'
          }}>
            <iframe title="Benchlands Drop Zone" width="100%" height="350" style={{maxWidth: '100%'}}
                    src="https://www.trailforks.com/widgets/skillpark/?id=9635&w=512px&h=350px&map=1&ttfs=1&photos=1&status=0"></iframe>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} >
          <Typography fontWeight={700} color="primary" textTransform="uppercase" textAlign="center"  sx={{
            fontSize: {xs: '1.5rem', md: '1.75rem'},
          }}>
            Millennium Bike Skills Park
          </Typography>
          <Box sx={{
            // border: `2px solid`,
            // borderColor: 'primary.main'
          }}>
            <iframe title="Benchlands Drop Zone" width="100%" height="350" style={{maxWidth: '100%'}}
                    src="https://www.trailforks.com/widgets/skillpark/?id=3298&w=512px&h=350px&map=1&ttfs=1&photos=1&status=0"></iframe>
          </Box>
        </Grid>
      </Grid>
      </Box>
    </Section>
  )
}

export default Trails
